export enum PageHeaderType {
  BIG_HERO_HEADER = 'Big Hero Header',
  BIG_TEXT_HEADER = 'Big Text Header',
  MEDIUM_HERO_HEADER = 'Medium Hero Header',
  SMALL_TEXT_HEADER = 'Small Text Header',
  SMALL_IMG_HEADER = 'Small Image Header',
}
